module.exports = __webpack_public_path__ + "6772c7957d99036b404210e28b846544.MP3";